import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '@pieskowo/shared';
import { setupPwa } from './pwa.js';
import { registerScenes } from './registry.js';
import { initSceneRouter } from './core/SceneRouter.js';
import { audioBus } from './core/AudioBus.js';
import { musicManager } from './core/MusicManager.js';
import { installTestHook } from './core/TestHook.js';
import { BootScene } from './scenes/boot/BootScene.js';
// WP-V2-WC: demo silnika świata pod ?world=1 (side-effect autoAttach)
import './core/world/installWorldDev.js';
// WP-V2-AV: demo awatara pod ?avatar=1 / ?anchors=1 (side-effect autoAttach)
import './avatar/installAvatarDev.js';
// WP-V2-IO: demo silnika interakcji pod ?interact=1 (side-effect autoAttach)
import './interact/installInteractDev.js';

setupPwa();
audioBus.load();
// G14: muzyka w tle — start po pierwszej interakcji (pointerdown), toggle musicOn
musicManager.init();

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#FFF3E9',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    activePointers: 3,
  },
  scene: [], // registered below
};

const game = new Phaser.Game(config);
registerScenes(game);
initSceneRouter(game);
installTestHook(game);
// Dev/debug: dostęp do scen z konsoli (nie w prod minified ścieżce krytycznej)
(window as unknown as { __pieskowo?: Phaser.Game }).__pieskowo = game;
game.scene.start(BootScene.KEY);

export { game };
